import { useControls } from "leva";
import * as THREE from 'three';

export const LightControls: React.FC = () => {
  const {
    intensity, color, px, mx, py, my, pz, mz
  } = useControls('Light', {
    intensity: {
      value: 3,
      min: 0,
      max: 30,
      step: 1,
    },
    color: '#f0f0f0',
    px: true,
    mx: true,
    py: true,
    my: true,
    pz: true,
    mz: true
  }, { collapsed: true });

  return (
    <>
      {px ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[1, 0, 0]} /> : null}
      {py ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[0, 1, 0]} /> : null}
      {pz ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[0, 0, 1]} /> : null}
      {mx ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[-1, 0, 0]} /> : null}
      {my ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[0, -1, 0]} /> : null}
      {mz ? <directionalLight intensity={intensity} color={new THREE.Color(color)} position={[0, 0, -1]} /> : null}
    </>
  );
};